"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Unarchive_1 = __importDefault(require("./Unarchive"));
const Archive_1 = __importDefault(require("./Archive"));
const Remove_1 = __importDefault(require("./Remove"));
const Leave_1 = __importDefault(require("./Leave"));
const Join_1 = __importDefault(require("./Join"));
const Add_1 = __importDefault(require("./Add"));
class Index {
    constructor(parent, chatId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.chatId = chatId;
    }
    path(withParameter = true) {
        if (withParameter && this.chatId !== null) {
            return `${this.parent.path()}/teams/${this.chatId}`;
        }
        return `${this.parent.path()}/teams`;
    }
    /**
     * Returns the list of teams where the user is a member (both archived and active) combined with a list of public teams that can be joined by the current user. All records in response are sorted by creation time of a chat in ascending order. A team is a chat between 2 and more (unlimited number) participants assigned with specific name.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/teams
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a team, and adds a list of people to the team.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async post(tMCreateTeamRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), tMCreateTeamRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information about the specified team.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/teams/{chatId}
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */
    async get(restRequestConfig) {
        if (this.chatId === null) {
            throw new Error('chatId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified team.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/teams/{chatId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async delete(restRequestConfig) {
        if (this.chatId === null) {
            throw new Error('chatId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the name and description of the specified team.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/teams/{chatId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async patch(tMUpdateTeamRequest, restRequestConfig) {
        if (this.chatId === null) {
            throw new Error('chatId must be specified.');
        }
        const r = await this.rc.patch(this.path(), tMUpdateTeamRequest, undefined, restRequestConfig);
        return r.data;
    }
    add() {
        return new Add_1.default(this);
    }
    join() {
        return new Join_1.default(this);
    }
    leave() {
        return new Leave_1.default(this);
    }
    remove() {
        return new Remove_1.default(this);
    }
    archive() {
        return new Archive_1.default(this);
    }
    unarchive() {
        return new Unarchive_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map